<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div [@routeAnimations]="getRouteAnimationData()">
  @if (hideHeaderAndFooter$ | async) {
    <router-outlet />
  } @else {
    <web-components-header />
    <router-outlet />
    <web-components-snackbar />
    <web-components-footer />
  }
  @if (appVersion) {
    <div class="app-version">v{{ appVersion }}</div>
  }
</div>
